import { NOTIFICATION_ENTITY_TYPES_CONST } from '@classictechsolutions/hubapi-transpiled-enums';
import { NavigationService } from '@app/core/services/navigation/navigation.service';
import { INotificationDto, NotificationLogicService } from '@app/logic/notification';
import { take } from 'rxjs';

export interface INotificationQueryParams {
    paramEntityId?: number;
    qnsId?: number;
    purchaseOrderId?: number;
}

export interface INotificationNavigation {
    url: string;
    queryParams: INotificationQueryParams;
}

export const getPrimaryEntityType = (notification: any): string => {
    switch (notification.primaryEntityType) {
        case 'ClientSale':
            return `/clientsales/view/${notification.primaryEntityId}`;
        case 'Lot':
            return `/lots/${notification.primaryEntityId}`;
        case 'BusinessAccount':
            return `/businessaccounts/edit/${notification.primaryEntityId}`;
        case 'BuildProgramme':
            return `/lots/${notification.primaryEntityId}/build/programme`;
        case 'Project':
            return `/projects/${notification.primaryEntityId}/releases/${notification.secondaryEntityId}`;
        case 'Lead':
            return `/leads/${notification.primaryEntityId}`;
        default:
            return `/${notification.primaryEntityType.toLocaleLowerCase()}s/edit/${notification.primaryEntityId}`;
    }
};

export const simplifySecondaryEntityType = (notification: any): string => {

    let returnValue: string;

    switch (notification.secondaryEntityType) {
        case 'WorkingDrawing':
            returnValue = '/design/working-drawings';
            break;
        case 'DesignScheme':
            returnValue = '/design/schemes';
            break;
        case 'PricingRevision':
            returnValue = '/costs/pricerevisions';
            break;
        case 'ChangeRecord':
            returnValue = '/changes/changes';
            break;
        case 'PurchaseOrder':
            returnValue = '/build/programme';
            break;
        case 'DocumentEntity':
            returnValue = '/documents';
            break;
        case 'Activity':
            returnValue = `/activity/${notification.secondaryEntityId}`;
            break;
        case 'TakeOffTask':
            returnValue = '/costs/takeoffs';
            break;
        case 'CouncilRfi':
            returnValue = '/design/council-rfis';
            break;
        case 'PreConsent':
            returnValue = '/design/pre-consent';
            break;
        case 'PreConsentPlan':
            returnValue = '/design/pre-consent';
            break;
        case 'Variation':
            returnValue = '/changes/variations';
            break;
        case 'Task':
            returnValue = '/tasks';
            break;
        case 'BuildingConsent':
            returnValue = '/design/consent';
            break;
        case 'BuildProgrammeActivity':
            returnValue = '/build/programme';
            break;
        case NOTIFICATION_ENTITY_TYPES_CONST.BUILD_PROGRAMME_DOCUMENT:
            returnValue = '/build/documents';
            break;
        default:
            return returnValue;
    }

    return returnValue;
};

export const getQueryParamsFromNotification = (notification: INotificationDto): INotificationQueryParams => {
    const queryParams: INotificationQueryParams = {
        paramEntityId: notification.secondaryEntityId,
        qnsId: notification.tertiaryEntityId
    };

    switch (notification.secondaryEntityType) {
        case 'PurchaseOrder':
            if (notification.secondaryEntityId > 0) {
                queryParams.purchaseOrderId = notification.secondaryEntityId;
            }
            break;
        default:
            break;
    }

    return queryParams;
};

export const getNotificationNavigation = (notification: INotificationDto): INotificationNavigation | null => {
    if (!notification?.primaryEntityType) {
        return null;
    }

    let url = getPrimaryEntityType(notification as any);
    if (notification.secondaryEntityType) {
        url += simplifySecondaryEntityType(notification as any);
    }

    return {
        url,
        queryParams: getQueryParamsFromNotification(notification)
    };
};

export const markAsReadAndNavigate = (
    notification: INotificationDto,
    notificationNavigation: INotificationNavigation,
    notificationLogicService: NotificationLogicService,
    navigationService: NavigationService
): void => {
    notificationLogicService.markAsRead(notification.id).pipe(take(1)).subscribe(() => {
        navigationService.navigate([notificationNavigation.url], undefined, {
            queryParams: notificationNavigation.queryParams
        });
    });
};
